import { useSelector } from "react-redux";
import {
  getCurrentHotspot,
  getCurrentStep,
  getHotspotTabContent,
} from "../../redux/selectors";
import { HotspotList } from "../HotspotList/HotspotList";
import HotspotCard from "../HotspotCard/HotspotCard";
import { AddHotspotButton } from "../HotspotListItem/AddHotspotButton";
import { hotspotTabContentStates } from "../../redux/ui/ui";
import { steps } from "../../util/constants";
import { TabHeader } from "../TabHeader/TabHeader";
import { HotspotListMoreMenu } from "../HotspotListMoreMenu/HotspotListMoreMenu";

export const HotspotsTab = () => {
  const hotspotIndex = useSelector(getCurrentHotspot);
  const hotspotTabContent = useSelector(getHotspotTabContent);
  const disabled = useSelector(getCurrentStep) === steps.configureLocations;
  return hotspotTabContent === hotspotTabContentStates.list ? (
    <>
      <div
        style={{
          height: "calc(100% - var(--hse-line-height))",
          maxHeight: "calc(100% - var(--hse-line-height))",
          overflowX: "hidden",
          padding: "8px 32px 20px 32px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <TabHeader>Hotspots</TabHeader>
          <HotspotListMoreMenu />
        </div>
        <HotspotList />
        {hotspotIndex === null ? <AddHotspotButton /> : null}
      </div>
    </>
  ) : (
    <HotspotCard disabled={disabled} />
  );
};
